<template>
  <div class="sp-template">
    <div class="h-title">编辑订单</div>
    <el-card class="box-card">
      <el-form :model="orderForm.deliveryDetail" size="small" :rules="orderFormRule" ref="orderForm1">
        <el-form-item label="取件方式" :label-width="formLabelWidth">
          <el-radio :disabled="disableForClaim" v-model="orderForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="PICK_UP_FROM_CUSTOMER">预约上门取件</el-radio>
          <span style="margin-left:30px;color:#666;">我们将在1-2天内上门取件，为收货方便，请提前准备好货物！当运费小于500元时，按货物重量收取费用，详情请查看</span>
          <el-button size="mini" type="text">《上门取件上说明》</el-button>
          <br />
          <el-radio :disabled="disableForClaim" v-model="orderForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="DELIVERY">送货至仓库</el-radio>
          <span style="margin-left:30px;color:#666;">请根据您的货物地址，选择距离货物最近的收货仓库</span>
          <br />
          <el-radio v-model="orderForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="DELIVERY_BY_EXPRESS">快递至仓库</el-radio>
          <span style="margin-left:30px;color:#666;">请根据您的货物地址，选择距离货物最近的收货仓库</span>
        </el-form-item>
        <el-form-item label="取件地址" :label-width="formLabelWidth" v-show="orderForm.deliveryDetail.deliveryType == 'PICK_UP_FROM_CUSTOMER'">
          <el-table :data="new Array(orderForm.deliveryDetail)" :show-header="false" class="table-list" style="width: 100%" v-show="orderForm.deliveryDetail.deliveryType == 'PICK_UP_FROM_CUSTOMER'">
            <el-table-column prop="province" label="地址" width="70"></el-table-column>
            <el-table-column prop="city" label="地址" width="90"></el-table-column>
            <el-table-column prop="addressFirst" label="地址" width="260"></el-table-column>
            <el-table-column prop="contractName" label="联系人" width="100"></el-table-column>
            <el-table-column prop="phone" label="电话" width="120"></el-table-column>
            <el-table-column label="操作" width="60">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑地址</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="交货仓库地址" :label-width="formLabelWidth">
          <el-select v-model="warehouseId" filterable v-if="flag" placeholder="请选择" @change="selectWarehouse">
            <el-option v-for="item in warehouse" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
          <el-table :data="userCarry" :show-header="false" class="table-list" style="width: 100%">
            <el-table-column label="仓库名称" width="100">
              <template slot-scope="scope">
                {{scope.row.title}}
              </template>
            </el-table-column>
            <el-table-column label="地址" width="320">
              <template slot-scope="scope">
                {{scope.row.address}}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="联系人" width="100"></el-table-column>
            <el-table-column prop="phone" label="电话" width="120"></el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item :label="orderForm.deliveryDetail.deliveryType == 'PICK_UP_FROM_CUSTOMER' ? '预约取件时间' : '预计送达时间'" :label-width="formLabelWidth" v-show="orderForm.deliveryDetail.deliveryType!='DELIVERY_BY_EXPRESS'" prop="appointmentAt">
          <el-date-picker v-model="orderForm.deliveryDetail.appointmentAt" :picker-options="appointmentAtOptions"
            type="datetime" placeholder="选择日期时间"  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-row>
          <el-col :span="10">
            <el-form-item label="快递公司" :label-width="formLabelWidth" v-show="orderForm.deliveryDetail.deliveryType == 'DELIVERY_BY_EXPRESS'" prop="expressCompany">
              <el-input :disabled="disableForClaim" v-model="orderForm.deliveryDetail.expressCompany" auto-complete="off" placeholder="快递公司"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="快递单号" :label-width="formLabelWidth" v-show="orderForm.deliveryDetail.deliveryType == 'DELIVERY_BY_EXPRESS'" prop="expressNumber">
              <el-input :disabled="disableForClaim" v-model="orderForm.deliveryDetail.expressNumber" auto-complete="off" placeholder="快递单号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
      </el-form>
      <h3 class="sp-card-title">订单信息
        <!-- <el-checkbox style="margin-left:20px;" v-model="fbaChecked" @change="changeShippingAddressType">FBA地址</el-checkbox> -->
      </h3>
      <el-form :model="orderForm.shippingDetail" size="small" :rules="orderFormRule2" ref="orderForm2">
        <el-row v-show="!fbaChecked">
          <el-col :span="10">
            <el-form-item label="客户单号" :label-width="formLabelWidth" prop="customerOrderNumber">
              <el-input v-model="orderForm.customerRefnumber.customerOrderNumber" auto-complete="off" placeholder="由系统提供，可修改"></el-input>
            </el-form-item>
            <el-form-item label="联系人" :label-width="formLabelWidth" prop="shippingContractName">
              <el-input v-model="orderForm.shippingDetail.contractName" auto-complete="off" placeholder="如已存在联系人，则自动补充后面信息"></el-input>
            </el-form-item>
            <el-form-item label="国家" :label-width="formLabelWidth" prop="shippingCountry">
              <el-input v-model="orderForm.shippingDetail.country" auto-complete="off"/>
            </el-form-item>
            <el-form-item label="城市" :label-width="formLabelWidth" prop="shippingCity">
              <el-input v-model="orderForm.shippingDetail.city" auto-complete="off"/>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="公司名称" :label-width="formLabelWidth">
              <el-input v-model="orderForm.shippingDetail.companyName" auto-complete="off" placeholder="公司名称"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" :label-width="formLabelWidth" prop="shippingPhone">
              <el-input v-model="orderForm.shippingDetail.phone" auto-complete="off" placeholder="联系电话"></el-input>
            </el-form-item>
            <el-form-item label="州/省" :label-width="formLabelWidth" prop="shippingProvince">
             <el-input v-model="orderForm.shippingDetail.province" auto-complete="off"/>
            </el-form-item>
            <el-form-item label="目的邮编" :label-width="formLabelWidth" prop="zipcode">
              <el-input v-model="orderForm.shippingDetail.zipcode" auto-complete="off" placeholder="目的邮编"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="详细地址1" :label-width="formLabelWidth" prop="shippingAddressFirst">
              <el-input v-model="orderForm.shippingDetail.addressFirst" auto-complete="off" class="width50"></el-input>
            </el-form-item>
            <el-form-item label="详细地址2" :label-width="formLabelWidth" prop="shippingAddressSecond">
              <el-input v-model="orderForm.shippingDetail.addressSecond" auto-complete="off" class="width50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="fbaChecked">
          <el-col :span="10">
            <el-form-item label="客户单号" :label-width="formLabelWidth">
              <el-input v-model="orderForm.customerRefnumber.customerOrderNumber" auto-complete="off" placeholder="由系统提供，可修改"></el-input>
            </el-form-item>
            <el-form-item label="公司名称" :label-width="formLabelWidth">
              <el-input v-model="orderForm.shippingDetail.companyName" auto-complete="off" placeholder="公司名称"></el-input>
            </el-form-item>
            <el-form-item label="产品名称" :label-width="formLabelWidth" prop="product">
              <el-select v-model="orderForm.productId" filterable @change="changeChannel">
                <el-option v-for="(p,i) in channelData" :key="i" :label="p.nameCN" :value="p.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="目的国家" :label-width="formLabelWidth">
              <el-input v-model="orderForm.shippingDetail.country" auto-complete="off" placeholder="根据仓码自动匹配"></el-input>
            </el-form-item>
            <el-form-item label="目的城市" :label-width="formLabelWidth">
              <el-input v-model="orderForm.shippingDetail.city" auto-complete="off" placeholder="根据仓码自动匹配，可修改"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="FBA号" :label-width="formLabelWidth">
              <el-input v-model="orderForm.customerRefnumber.fbaNumber" auto-complete="off" placeholder="FBA号"></el-input>
            </el-form-item>
            <el-form-item label="FBA仓码" :label-width="formLabelWidth">
              <el-select v-model="orderForm.shippingDetail.fbaWarehouseCode" @change="changeFbaWarehouseCode">
                <el-option v-for="(fba,i) in initialDataFbaAddress" :key="i" :label="fba.warehouseCode" :value="fba.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="省/州" :label-width="formLabelWidth">
              <el-input v-model="orderForm.shippingDetail.province" auto-complete="off" placeholder="根据仓码自动匹配"></el-input>
            </el-form-item>
            <el-form-item label="目的邮编" :label-width="formLabelWidth">
              <el-input v-model="orderForm.shippingDetail.zipcode" auto-complete="off" placeholder="根据仓码自动匹配，可修改"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="详细地址" :label-width="formLabelWidth">
              <el-input v-model="orderForm.shippingDetail.addressFirst" auto-complete="off" class="width50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Amazon Reference ID" :label-width="formLabelWidth">
              <el-input v-model="orderForm.amazonReferenceId" auto-complete="off" class="width50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <h3 class="sp-card-title">商品信息
        <el-checkbox :disabled="disableForClaim" style="margin-left:20px;" v-model="formData.usMeasure">以承运商测量数据为准</el-checkbox>
      </h3>
      <el-form :model="orderForm.packingList" size="small" :rules="orderFormRule3" ref="orderForm3">
        <el-row>
          <el-col :span="10">
            <el-form-item label="货物类型" :label-width="formLabelWidth" prop="goodsType">
              <el-select v-model="orderForm.packingList.goodsType">
                <el-option label="普货" value="COMMON"></el-option>
                <el-option label="带电" value="CHARGED"></el-option>
                <el-option label="带磁" value="MAGNETIC"></el-option>
                <el-option label="带电带磁" value="CHARGED_MAGNETIC"></el-option>
              </el-select>
            </el-form-item>
            
          <el-col :span="10">
            <el-form-item label="是否购买保险" :label-width="formLabelWidth">
              <el-checkbox v-model="orderForm.purchaseInsurance"></el-checkbox>
            </el-form-item>
          </el-col>

          </el-col>
          <el-col :span="10">
            <el-form-item label="货物箱数" :label-width="formLabelWidth" prop="totalCarton">
              <el-input :disabled="disableForClaim" v-model="orderForm.packingList.totalCarton" auto-complete="off" type="number" placeholder="货物箱数"></el-input>
            </el-form-item>
            <el-form-item label="一般贸易" :label-width="formLabelWidth">
              <el-checkbox v-model="orderForm.generalTrade" :checked="true"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>

        <el-button :disabled="disableForClaim" type="text" @click="handleEditGuige">添加箱子信息</el-button>
        <el-table :data="guigeArr" border v-show="productForm.guigeRadio == 2" class="m-b-20">
          <el-table-column property="customerCartonNumber" label="客户箱号"></el-table-column>
          <el-table-column property="number" label="箱数"></el-table-column>
          <el-table-column property="long" label="长(cm)"></el-table-column>
          <el-table-column property="width" label="宽(cm)"></el-table-column>
          <el-table-column property="height" label="高(cm)"></el-table-column>
          <el-table-column property="weight" label="毛重(kg)"></el-table-column>
          <el-table-column label="SKU信息">
            <template slot-scope="scope">
              <p v-for="(d,i) in scope.row.skus" :key="i">{{d.sku}} * {{d.number}}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="measureEditSkus(scope.$index)">添加/编辑SKU</el-button>
              <i v-show="!disableForClaim" class="el-icon-edit-outline" @click="handleEditGuige( scope.row, scope.$index)"></i>
              <i v-show="!disableForClaim" class="el-icon-delete" @click="handleDeleteGuige(scope.row, scope.$index)"></i>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="10" v-show="!formData.usMeasure">
            <el-form-item label="总体积(cbm)" :label-width="formLabelWidth" v-show="!formData.usMeasure">
              <el-input v-model="allTiji" auto-complete="off" placeholder="总体积"></el-input>
              <el-tooltip class="item" effect="dark" content="仅供参考" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="总重量(kg)" :label-width="formLabelWidth" v-show="!formData.usMeasure">
              <el-input v-model="allWeight" auto-complete="off" placeholder="总重量"></el-input>
              <el-tooltip class="item" effect="dark" content="仅供参考" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item :label-width="formLabelWidth">
          <el-button size="small" @click="back">返 回</el-button>
          <el-button size="small" type="primary" @click="editOrderSubmit">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 地图 -->
    <!-- <sp-amap id="sp-amap" v-if="initialDataWarehouseAddress.length != 0" width="100%" :class="{isOpen: isOpen}" :markers="initialDataWarehouseAddress" :isOpen="isOpen" @get-map-form="getMapForm" @get-geocoder="getGeocoder"></sp-amap> -->

    <!-- 上门取件弹层 -->
    <el-dialog title="编辑地址" :visible.sync="addressFormVisible">
      <el-form size="small" :model="addressForm">
        <el-form-item label="州/省" :label-width="formLabelWidth">
          <el-select v-model="orderForm.deliveryDetail.province" @change="queryCityOfChina" filterable>
            <el-option v-for="(province,i) in initialDataProvinceChina" :key="i" :label="province.nameCn" :value="province.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市" :label-width="formLabelWidth">
          <el-select v-model="orderForm.deliveryDetail.city" filterable>
            <el-option v-for="(city,i) in initialDataCityChina" :key="i" :label="city.nameCn" :value="city.nameCn"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址" :label-width="formLabelWidth">
          <el-input v-model.lazy="orderForm.deliveryDetail.addressFirst" placeholder="详细地址"></el-input>
        </el-form-item>
        <el-form-item label="联系人" :label-width="formLabelWidth">
          <el-input v-model.lazy="orderForm.deliveryDetail.contractName" placeholder="联系人"></el-input>
        </el-form-item>
        <el-form-item label="电话" :label-width="formLabelWidth">
          <el-input v-model.lazy="orderForm.deliveryDetail.phone" placeholder="电话"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveAddressOfDeliver">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 非上门取件弹层 -->
    <el-dialog title="选取地址" :visible.sync="mapAddressFormVisible" class="gaide-map">
      <!--高德地图-->
      <div ref="spAmap"></div>
      <el-form size="small" class="m-t-20">
        <el-form-item label="已选地址" label-width="70px">
          <b v-text="mapObj.title"></b>
          <span v-text="mapObj.address"></span>
        </el-form-item>
        <el-form-item label="联系人" label-width="70px">
          <span v-text="mapObj.name"></span>
        </el-form-item>
        <el-form-item label="联系电话" label-width="70px">
          <span v-text="mapObj.phone"></span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSmenSaveMap">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 添加SKU -->
    <el-dialog class="sp-info-box" title="商品信息" :visible.sync="listTable" @close="skuEditClose">
      <div class="">
        <div style="margin-bottom:10px;">
          <div class="clearfix">
            <div style="float:right;">
              <button type="button" class="el-button el-button--default el-button--small" @click="spHandleEdit">
                <span>新增</span>
              </button>
              <button type="button" class="el-button el-button--default el-button--small" @click="lishiTable = true">
                <span>历史商品列表</span>
              </button>
              <button type="button" class="el-button el-button--default el-button--small" v-show="false">
                <span>批量导入商品</span>
              </button>
            </div>
          </div>
        </div>
        <el-table :data="spList" tooltip-effect="dark" style="width: 100%">
          <el-table-column prop="sku" label="SKU">
          </el-table-column>
          <el-table-column prop="zhName" label="中文品名"></el-table-column>
          <el-table-column prop="enName" label="英文品名"></el-table-column>
          <el-table-column prop="code" label="海关编码"></el-table-column>
          <el-table-column prop="money" label="申报价值"></el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="图片">
            <template slot-scope="scope">
              <img width="65" height="45" :src="scope.row.img">
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button size="mini" @click="spHandleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="spHandleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="skuSaveSp">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 添加箱子信息 -->
    <el-dialog :title="cartonDialogTitle" :visible.sync="addGuigeShow">
      <el-form size="small" :model="addGuige" :rules="rulesAddGuige" ref="addGuige">
        <el-form-item v-show="false">
          <el-input v-model="addGuigeIndex" type="number" placeholder="index"></el-input>
        </el-form-item>
        <el-form-item v-if="false" label="客户箱号" :label-width="formLabelWidth" class="must">
          <el-input v-model="addGuige.customerCartonNumber" placeholder="客户箱号(如填客户箱号,箱数只能为1)"></el-input>
        </el-form-item>
        <el-form-item label="箱数" :label-width="formLabelWidth" class="must" prop="number">
          <el-input v-model="addGuige.number" type="number" placeholder="箱数"></el-input>
        </el-form-item>
        <el-form-item label="长(CM)" :label-width="formLabelWidth" class="must" prop="long" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.long" type="number" placeholder="长"></el-input>
        </el-form-item>
        <el-form-item label="宽(CM)" :label-width="formLabelWidth" class="must" prop="width" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.width" type="number" placeholder="宽"></el-input>
        </el-form-item>
        <el-form-item label="高(CM)" :label-width="formLabelWidth" class="must" prop="height" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.height" type="number" placeholder="高"></el-input>
        </el-form-item>
        <el-form-item label="毛重(KG)" :label-width="formLabelWidth" class="must" prop="weight" v-show="formData.usMeasure == false">
          <el-input v-model="addGuige.weight" type="number" placeholder="毛重"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" class="erro-info">
          <div class="erro-info-text" v-text="addGuigeErro"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="handleSaveguige">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 历史商品列表弹层 -->
    <el-dialog title="历史商品列表" :visible.sync="lishiTable">
      <el-table :data="productData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="sku" label="SKU">
        </el-table-column>
        <el-table-column prop="nameCn" label="中文品名"></el-table-column>
        <el-table-column prop="nameEn" label="英文品名"></el-table-column>
        <el-table-column prop="hscode" label="海关编码"></el-table-column>
        <el-table-column prop="price" label="申报价值"></el-table-column>
        <el-table-column prop="img" label="图片">
          <template slot-scope="scope">
            <img width="65" height="45" :src="scope.row.picture">
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="productHistoryList.total" :page-size="productHistoryList.pageSize" :current-page="productHistoryList.page" @current-change="currentPage" class="t-a-r m-t-20"></el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="handleSaveSp">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新增商品信息弹层 -->
    <el-dialog :title="editProductTitle" :visible.sync="addSPinfo">
      <el-form size="small" label-width="80px" :model="tmpProduct" :rules="rulesTmpProduct" ref="tmpProduct">
        <el-form-item label="SKU" prop="sku">
          <el-input placeholder="id" v-show="false" v-model="tmpProduct.id"></el-input>
          <el-input placeholder="SKU" v-model="tmpProduct.sku"></el-input>
        </el-form-item>
        <el-form-item label="中文品名" prop="zhName">
          <el-input placeholder="中文品名" v-model="tmpProduct.zhName"></el-input>
        </el-form-item>
        <el-form-item label="海关编码" prop="code">
          <el-input placeholder="海关编码" v-model="tmpProduct.code"></el-input>
        </el-form-item>
        <el-form-item label="英文品名" prop="enName">
          <el-input placeholder="英文品名" v-model="tmpProduct.enName"></el-input>
        </el-form-item>
        <el-form-item label="单个净重" prop="weight">
          <el-input type="number" placeholder="单个净重" v-model.number="tmpProduct.weight"></el-input>
        </el-form-item>
        <el-form-item label="单个产品申报价值" prop="money">
          <el-select v-model="tmpProduct.currency" placeholder="请选择币种" size="small" class="w-150">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-input type="number" placeholder="单个产品申报价值" v-model.number="tmpProduct.money"></el-input>
        </el-form-item>
        <el-form-item label="商品图片" :label-width="formLabelWidth" prop="img">
          <el-upload action="#" :file-list="imgFile" list-type="picture-card" :limit="1" :on-change="imgChange" :auto-upload="false">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" v-show="nextAddProductButton" @click="handleAddSpContinue">继续添加</el-button>
        <el-button type="success" @click="handleAddSp">完 成</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import formatDate from "../../../utils/formatDate.js";

function clone(obj) {
  if (!obj || typeof obj != "object") return obj;
  let _newObj = new Object();
  for (let key in obj) {
    _newObj[key] = clone(obj[key]);
  }
  return _newObj;
}

export default {
  components: {},
  data() {
    var checkNumber = (rule, value, callback) => {
      if (!this.formData.usMeasure) {
        if (!/^\d+.?\d{0,4}$/.test(value) || value <= 0) {
          callback(new Error("请输入大于0的整数或小数,小数最大精确4位"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var checkInteger = (rule, value, callback) => {
      if (!/^\d+$/.test(value) || value <= 0) {
        callback(new Error("请输入大于0的整数"));
      } else {
        callback();
      }
    };
    var checkFormHeadDate = (rule, value, callback) => {
      if (
        this.orderForm.deliveryDetail.deliveryType == "DELIVERY" ||
        this.orderForm.deliveryDetail.deliveryType == "PICK_UP_FROM_CUSTOMER"
      ) {
        if (!value || value == "") {
          callback(new Error("日期不能为空，请选择日期"));
        } else {
          //地址校验
          if (
            this.orderForm.deliveryDetail.addressFirst == "" ||
            this.orderForm.deliveryDetail.city == "" ||
            this.orderForm.deliveryDetail.contractName == "" ||
            this.orderForm.deliveryDetail.phone == "" ||
            this.orderForm.deliveryDetail.province == ""
          ) {
            callback(new Error("请点击'编辑地址'按钮补全地址信息"));
          } else {
            callback();
          }
        }
      } else {
        callback();
      }
    };
    var checkFormHeadText = (rule, value, callback) => {
      if (this.orderForm.deliveryDetail.deliveryType == "DELIVERY_BY_EXPRESS") {
        if (!value || value == "") {
          callback(new Error("快递信息不能为空"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var checkFormBodyTextorderNumber = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.customerRefnumber.customerOrderNumber == "")
          callback(new Error("客户单号必填"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextaddressFirst = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.addressFirst == "")
          callback(new Error("详细地址1必填"));
        callback();
      } else {
        callback();
      }
    };

    var checkFormBodyTextcity = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.city == "")
          callback(new Error("城市必选"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextcontractName = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.contractName == "")
          callback(new Error("联系人必填"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyText = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.country == "")
          callback(new Error("国家必选"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextcountry = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.country == "")
          callback(new Error("国家必选"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextphone = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.phone == "")
          callback(new Error("联系电话"));
        callback();
      } else {
        callback();
      }
    };
    var checkFormBodyTextprovince = (rule, value, callback) => {
      if (!this.fbaChecked) {
        if (this.orderForm.shippingDetail.province == "")
          callback(new Error("省份&州必选"));
        callback();
      } else {
        callback();
      }
    };

    var checkFormBottomTotalCarton = (rule, value, callback) => {
      if (!value || !parseInt(value) || isNaN(value) || parseInt(value) <= 0) {
        callback(new Error("货物箱数必须为大于0的整数"));
      } else {
        callback();
      }
    };

    return {
      imgFile: [],
      //高德地图
      isInit: true,
      isOpen: false,

      mapObj: {},
      userCarry: [
        {
          title: "",
          address: "",
          name: "",
          phone: "",
          distance: ""
        }
      ],
      mapAddressFormVisible: false,
      fbaChecked: true,
      formData: {
        usMeasure: false
      },

      form: {
        test: "",
        radio: "1"
      },
      originalZipcode: "", //原始邮编
      orderForm: {
        orgOwner: "",
        orgOp: "",
        warehoustCode: "",
        productId: "",
        remark: "",
        customsId: "",
        customerRefnumber: { customerOrderNumber: "", fbaNumber: "" },
        deliveryDetail: {
          deliveryType: "PICK_UP_FROM_CUSTOMER",
          warehouseCode: "",
          appointmentAt: formatDate(new Date()),
          expressCompany: "",
          expressNumber: "",
          contractName: "",
          phone: "",
          country: "",
          province: "",
          city: "",
          addressFirst: ""
        },
        shippingDetail: {
          contractName: "",
          phone: "",
          country: "",
          countryId: "",
          province: "",
          city: "",
          zipcode: "",
          addressFirst: "",
          addressSecond: "",
          fbaWarehouseCode: "",
          companyName: ""
        },
        packingList: {
          goodsType: "",
          totalCarton: "",
          cartonDetails: []
        },
        localLanguageDetailValue: {
          contractName: "",
          country: "",
          province: "",
          city: "",
          addressFirst: "",
          addressSecond: ""
        },
        generalTrade: true,
        amazonReferenceId: "",
        purchaseInsurance: false
      },
      shippingDetail: {
        countryId: "",
        provinceId: "",
        cityId: ""
      },
      deliveryDetail: {
        provinceId: ""
      },
      productData: [],
      tmpProduct: {
        id: "",
        currency: "",
        sku: "",
        weight: "",
        nameCn: "",
        nameEn: "",
        hscode: "",
        price: "",
        img: ""
      },
      orderFormRule: {
        appointmentAt: [
          {
            validator: checkFormHeadDate,
            trigger: "change"
          }
        ],
        expressCompany: [
          {
            validator: checkFormHeadText,
            trigger: "blur"
          }
        ],
        expressNumber: [
          {
            validator: checkFormHeadText,
            trigger: "blur"
          }
        ],
        customerOrderNumber: [
          {
            required: true,
            message: "请填写快递单号",
            trigger: "blur"
          }
        ]
      },
      orderFormRule3: {
        goodsType: [
          {
            required: true,
            message: "请选择货物类型",
            trigger: "change"
          }
        ],
        totalCarton: [
          {
            validator: checkFormBottomTotalCarton,
            trigger: "blur"
          }
        ]
      },
      orderFormRule2: {
        customerOrderNumber: [
          {
            validator: checkFormBodyTextorderNumber,
            trigger: "change"
          }
        ],
        shippingPhone: [
          {
            validator: checkFormBodyTextphone,
            trigger: "change"
          }
        ],
        shippingProvince: [
          {
            validator: checkFormBodyTextprovince,
            trigger: "change"
          }
        ],
        zipcode: [{ required: true, message: "请输入邮编", trigger: "blur" }],
        shippingContractName: [
          {
            validator: checkFormBodyTextcontractName,
            trigger: "change"
          }
        ],
        shippingCountry: [
          {
            validator: checkFormBodyTextcountry,
            trigger: "change"
          }
        ],
        shippingCity: [
          {
            validator: checkFormBodyTextcity,
            trigger: "change"
          }
        ],
        shippingAddressFirst: [
          {
            validator: checkFormBodyTextaddressFirst,
            trigger: "change"
          }
        ]
      },
      rulesTmpProduct: {
        sku: [
          {
            required: true,
            message: "请输入SKU",
            trigger: "blur"
          }
        ],
        nameCn: [
          {
            required: true,
            message: "请输入中文品名",
            trigger: "blur"
          }
        ],
        hscode: [
          {
            required: true,
            message: "请输入海关编码",
            trigger: "blur"
          }
        ],
        nameEn: [
          {
            required: true,
            message: "请输入英文品名",
            trigger: "blur"
          }
        ],
        weight: [
          {
            required: true,
            message: "请输入重量",
            trigger: "blur"
          },
          {
            type: "number",
            message: "重量必须是数字",
            trigger: "blur"
          }
        ],
        price: [
          {
            required: true,
            message: "请输入单个产品申报金额",
            trigger: "blur"
          },
          {
            type: "number",
            message: "申报金额必须是数字",
            trigger: "blur"
          }
        ]
      },
      productHistoryList: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      productForm: {
        test: "",
        guigeRadio: "1",
        select: "shanghai",
        boxNumber: 0
      },
      //上门取件
      tableAddressData: [
        {
          address: "广东省深圳市南山区学府路南山智园B11栋14楼(Daniel)",
          name: "blry",
          phone: "18682152960"
        }
      ],
      addressForm: {
        address: "广东省深圳市南山区学府路南山智园B11栋14楼(Daniel)",
        name: "blry",
        phone: "18682152960"
      },
      addressFormVisible: false,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      options: [
        {
          value: "RMB",
          label: "人民币"
        },
        {
          value: "HKD",
          label: "港币"
        },
        {
          value: "GBP",
          label: "英镑"
        },
        {
          value: "USD",
          label: "美元"
        },
        {
          value: "JPY",
          label: "日元"
        },
        {
          value: "EUR",
          label: "欧元"
        }
      ],
      value: "",
      guige: {
        long: "",
        width: "",
        height: "",
        weight: ""
      },
      guigeArr: [],
      addGuige: {
        customerCartonNumber: "",
        number: "",
        long: "",
        width: "",
        height: "",
        weight: ""
      },
      originItemNum: 0,
      addGuigeErro: "",
      addGuigeShow: false,
      listTable: false, //添加sku
      addSPinfo: false,
      lishiTable: false,
      spList: [], //sku列表
      spListIndex: "",
      spListIndexData: "",
      standardSkus: [], //每箱同sku
      customsList: [],
      originCustomsId: "",
      lishiList: [
        {
          sku: "HF001",
          zhName: "黑色签字笔",
          enName: "pen",
          code: "547896542",
          money: "￥5.00",
          img:
            "https://y.gtimg.cn/music/photo_new/T001R300x300M000002J4UUk29y8BY.jpg?max_age=2592000"
        }
      ],
      dialogImageUrl: "", //上传图片
      dialogVisible: false,
      initialDataFbaAddress: [],
      initialDataCountry: [],
      initialDataProvince: [],
      initialDataCity: [],
      initialDataProvinceChina: [],
      initialDataCityChina: [],
      initialDataWarehouseAddress: [],
      currentWarehouseAddress: "",
      addImg: "",
      cartonDialogTitle: "添加货物信息",
      addGuigeIndex: "",
      rulesAddGuige: {
        number: [
          {
            validator: checkInteger,
            trigger: "blur"
          }
        ],
        long: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        width: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        height: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ],
        weight: [
          {
            validator: checkNumber,
            trigger: "blur"
          }
        ]
      },
      appointmentAtOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "明天",
            onClick(picker) {
              let _tomorrow = new Date(
                new Date(
                  new Date().getTime() + 3600 * 1000 * 24
                ).toLocaleDateString()
              );
              picker.$emit("pick", _tomorrow);
            }
          },
          {
            text: "后天",
            onClick(picker) {
              let _afterTomorrow = new Date(
                new Date(
                  new Date().getTime() + 3600 * 1000 * 24 * 2
                ).toLocaleDateString()
              );
              picker.$emit("pick", _afterTomorrow);
            }
          }
        ],
        disabledDate(time) {
          return time < new Date(new Date().toLocaleDateString()).getTime();
        }
      },
      editProductTitle: "新增商品信息",
      nextAddProductButton: true,
      clone(obj) {
        if (!obj || typeof obj != "object") return obj;
        let _newObj = new Object();
        for (let key in obj) {
          _newObj[key] = clone(obj[key]);
        }
        return _newObj;
      },
      shippingList: [],
      shippingId: "",
      disableForClaim: false,
      //edit order
      editOrderId: "",
      default_warehouseCode: "", // 订单默认的仓库
      channelData: [],
      flag: false,
      warehouseData: [],
      warehouseId: "",
      warehouse: []
    };
  },

  computed: {
    filterCustomsList: function() {
      var key = this.key;
      var customsList = this.customsList;
      return customsList.filter(function(item) {
        if (item.status === 0) {
          item.customsName = item.customsName + "-已停用";
        }
        return item;
      });
    },
    //总体积
    allTiji: function() {
      if (this.productForm.guigeRadio == "1") {
        if (
          this.orderForm.packingList.totalCarton &&
          this.guige.long &&
          this.guige.width &&
          this.guige.height
        ) {
          return (
            (parseInt(this.orderForm.packingList.totalCarton) *
              parseInt(this.guige.long) *
              parseInt(this.guige.width) *
              parseInt(this.guige.height)) /
            1000000
          ).toFixed(4);
        } else {
          return 0;
        }
      } else {
        if (this.guigeArr.length > 0) {
          let num = 0;
          this.guigeArr.forEach((d, i) => {
            if (d.number && d.long && d.width && d.height) {
              num +=
                (parseInt(d.number) *
                  parseInt(d.long) *
                  parseInt(d.width) *
                  parseInt(d.height)) /
                1000000;
            }
          });
          return num.toFixed(4);
        } else {
          return 0;
        }
      }
    },
    //总重量
    allWeight: function() {
      if (this.productForm.guigeRadio == "1") {
        let weight =
          this.guige.weight && this.orderForm.packingList.totalCarton
            ? parseInt(this.orderForm.packingList.totalCarton) *
              parseFloat(this.guige.weight)
            : 0;
        if (this.orderForm.packingList.totalCarton && this.guige.weight) {
          return weight.toFixed(4);
        } else {
          return 0;
        }
      } else {
        if (this.guigeArr.length == 0) return 0;
        let num = 0;
        this.guigeArr.forEach((d, i) => {
          if (d.number && d.weight) {
            num += parseInt(d.number) * parseInt(d.weight);
          }
        });
        return num.toFixed(4);
      }
    }
  },
  watch: {},

  created() {
    // init data
    var _this = this;
    this.editOrderId = this.$route.query.orderId;
    _this.queryProvinceOfChina();
    _this.loadChannel();

    setTimeout(() => {
      _this.loadProducts();
      _this.queryWarehouseData(); //查询FBA地址
      // _this.queryAddress("SHIPPING");
      _this.loadCustomerAddress();
      _this.queryCustomsList();
    }, 800);
    if (this.editOrderId) {
      this.showOrderDetailById(this.editOrderId);
    }
  },
  methods: {
    setCustomsEmpty() {
      var flag = true; //默认是后台得清关ID
      var customsId = this.orderForm.customsId;
      var customsList = this.customsList;
      customsList.forEach((d, i) => {
        if (d.customsId == customsId) {
          flag = false; //说明是客户端得清关行
        }
      });
      if (flag) {
        this.originCustomsId = this.orderForm.customsId; //暂存后台清关ID
        this.orderForm.customsId = ""; //清空清关ID
      }
    },
    //查询清关行&报关行
    queryCustomsList() {
      let _this = this;
      _this.$request1
        .get(
          '/customs/load',
          {
            params: {
              customsName: "",
              customsType: "",
              currentPage: 1,
              pageSize: 100
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.customsList = response.data.data;
            _this.setCustomsEmpty();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    changeChannel() {
      this.queryFbaAddress();
      this.queryCountrys();
    },
    //查询订单信息
    showOrderDetailById(editOrderId) {
      let _this = this;
      this.$request1
        .get(
          '/order/' + editOrderId + '/edit/query',
          {
            withCredentials: true
          }
        )
        .then(res => {
          if (res.data.success) {
            this.productForm.guigeRadio = "2";
            this.orderForm = res.data.data;
            this.default_warehouseCode = res.data.data.warehoustCode;
            let addr = res.data.data.shippingDetail
            if(!addr.fbaWarehouseCode || addr.fbaWarehouseCode === '无'){
              this.fbaChecked = false
            }
            this.originalZipcode = this.orderForm.shippingDetail.zipcode;
            this.guigeArr = [];
            this.orderForm.packingList.cartonDetails.forEach((d, i) => {
              let cartonSkus = [];
              d.items.forEach((s, k) => {
                cartonSkus.push({
                  sku: s.sku,
                  number: s.qty
                });
              });
              this.guigeArr.push({
                customerCartonNumber: d.customerCartonNumber,
                number: 1,
                long: d.length,
                width: d.width,
                height: d.height,
                weight: d.weight,
                skus: cartonSkus
              });
            });
            this.queryFbaAddress();
            this.queryCountrys();
            // console.log("this.orderForm:"+JSON.stringify(this.orderForm));
            // console.log("this.originalZipcode:"+this.originalZipcode);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadChannel() {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/channel'
      })
        .then(response => {
          let result = response.data;
          // console.info("channel res:"+JSON.stringify(result.data));
          if (result.data && result.data.length > 0) {
            this.channelData = result.data;
          } else {
            this.channelData = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    initialFormStatus() {
      let _this = this;
      let claim = _this.$route.query.claim;
      if (claim && claim != "") {
        _this.disableForClaim = true;
        _this.orderForm.deliveryDetail.deliveryType = "DELIVERY_BY_EXPRESS";
        _this.formData.usMeasure = true;
        _this.productForm.guigeRadio = "2";

        //查询claim
        _this.$request1
          .post(
            '/claim/query',
            {
                id: claim,
                warehouseId: "",
                expressCompany: "",
                expressCode: "",
                orderId: "",
                claimed: false,
                startDate: "",
                endDate: "",
                currentPage: 1,
                pageSize: 1000
              },
            {
              withCredentials: true
            }
          )
          .then(function(res) {
            // console.log(res);
            if (res.data.success) {
              _this.orderForm.deliveryDetail.expressNumber =
                res.data.data[0].expressCode;
              _this.orderForm.deliveryDetail.expressCompany =
                res.data.data[0].expressCompany;
              _this.orderForm.packingList.totalCarton = res.data.data[0].qty;
              res.data.data[0].cartonCodes.split(",").forEach((d, i) => {
                let addGuige = {
                  customerCartonNumber: d,
                  number: 1,
                  long: "",
                  width: "",
                  height: "",
                  weight: ""
                };
                _this.guigeArr.push(addGuige);
              });
              _this.$request1({
                  method: 'GET',
                  url: '/warehouse/list',
                  xhrFields: {
                    withCredentials: true
                  }
                })
                .then(response => {
                  _this.warehouseData = response.data.data;
                  response.data.data.forEach((d, i) => {
                    d.title = d.name;
                    d.position = d.position.split(",");
                  });
                  _this.initialDataWarehouseAddress = response.data.data;

                  _this.initialDataWarehouseAddress.forEach((d, i) => {
                    if (d.id == res.data.data[0].warehouseId) {
                      _this.currentWarehouseAddress = d;
                    }
                  });
                })
                .catch(error => {
                  console.log(error);
                });
            } else {
              _this.$message.error(res.data.message);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    back() {
      this.$router.go(-1);
    },
    //高德地图保存地址
    handleSmenSaveMap() {
      this.mapAddressFormVisible = false;
      this.userCarry[0].title = this.mapObj.title;
      this.userCarry[0].address = this.mapObj.address;
      this.userCarry[0].name = this.mapObj.name;
      this.userCarry[0].phone = this.mapObj.phone;
      this.userCarry[0].distance = this.mapObj.distance;
    },
    //点击仓库
    getMapForm(val) {
      this.mapObj = val;
      // console.log("选择仓库： " + JSON.stringify(val));
      this.currentWarehouseAddress = val;
      if (
        this.orderForm.deliveryDetail.deliveryType == "DELIVERY" ||
        this.orderForm.deliveryDetail.deliveryType == "DELIVERY_BY_EXPRESS"
      ) {
        this.orderForm.deliveryDetail.warehouseCode = val.id;
        this.orderForm.deliveryDetail.contractName = val.receiptPersonName;
        this.orderForm.deliveryDetail.phone = val.receiptPersonPhone;
        this.orderForm.deliveryDetail.country = val.countryCode;
        this.orderForm.deliveryDetail.province = val.province;
        this.orderForm.deliveryDetail.city = val.city;
        this.orderForm.deliveryDetail.addressFirst = val.address;
      } else {
        this.orderForm.deliveryDetail.warehouseCode = val.id;
      }

      if (this.isInit) {
        this.userCarry[0].title = val.title;
        this.userCarry[0].address = val.address;
        this.userCarry[0].name = val.name;
        this.userCarry[0].phone = val.phone;
        this.userCarry[0].distance = val.distance;
        this.isInit = false;
      }
    },
    //获取经纬度：
    getGeocoder(val) {
      console.log("获取经纬度： " + JSON.stringify(val));
    },
    //地图编辑地址
    handleMapEdit(index, row) {
      var self = this;
      this.mapAddressFormVisible = true;
      if (!this.isOpen) {
        clearTimeout(timer);
        let timer = setTimeout(function() {
          self.$refs.spAmap.appendChild(document.getElementById("sp-amap"));
          self.isOpen = true;
        }, 50);
      }
      // console.log(index, row);
    },
    //编辑地址
    handleEdit(index, row) {
      this.addressFormVisible = true;
      // console.log(index, row);
    },
    //------------------箱子信息-----------------------------------------//
    //保存
    handleSaveguige() {
      let _this = this;
      let _valid = false;
      _this.$refs["addGuige"].validate(valid => {
        if (!valid) {
          _valid = false;
        } else {
          _valid = true;
        }
      });
      if (!_valid) {
        return false;
      }
      for (let key in _this.addGuige) {
        let item = _this.addGuige[key];
        if (
          !_this.formData.usMeasure &&
          (!item || isNaN(item) || parseFloat(item) <= 0)
        ) {
          //SPFunc.spAlert(_this, "必须大于0");
          //return;
        }
      }
      this.addGuigeShow = false;
      if (this.addGuigeIndex !== undefined && !isNaN(this.addGuigeIndex)) {
        this.guigeArr.splice(this.addGuigeIndex, 1, this.addGuige);
      } else {
        this.guigeArr.push(this.addGuige);
      }
      this.orderForm.packingList.totalCarton =
        Number(this.orderForm.packingList.totalCarton) +
        Number(this.addGuige.number) -
        this.originItemNum;
      this.addGuigeIndex = undefined;
      this.addGuige = {
        customerCartonNumber: "",
        number: "",
        long: "",
        width: "",
        height: "",
        weight: ""
      };
    },
    //新增/编辑箱子信息
    handleEditGuige(item, index) {
      this.addGuigeShow = true;
      this.addGuigeIndex = index;
      this.addGuige = {
        customerCartonNumber: "",
        number: "",
        long: "",
        width: "",
        height: "",
        weight: ""
      };
      this.cartonDialogTitle = "添加货物信息";
      if (index || index >= 0) {
        this.cartonDialogTitle = "编辑货物信息";
        this.addGuige = item;
        this.originItemNum = item.number;
      } else {
        this.originItemNum = 0;
      }
    },
    measureEditSkus(index) {
      //箱子规格不同编辑sku
      let _this = this;
      // console.log(_this.guigeArr[index]);
      if (_this.guigeArr[index]) {
        if (_this.guigeArr[index].skus) {
          //查询sku的信息
          let skus = [];
          _this.guigeArr[index].skus.forEach((s, i) => {
            skus.push(s.sku);
          });
          let cartonSkuMaps = [];
          _this.spList = [];
          _this.$request1
            .get(
              '/center/query/skus',
              {
                params: {
                  skus: skus,
                  orgOwner: _this.orderForm.orgOwner
                },
                withCredentials: true,
                headers: {
                  "content-type": "application/json"
                }
              }
            )
            .then(res => {
              if (res.data.success) {
                if (res.data.data.length > 0) {
                  res.data.data.forEach((sku, i) => {
                    cartonSkuMaps[sku.sku] = sku;
                  });
                }
                _this.guigeArr[index].skus.forEach((s, j) => {
                  let cartonSku = cartonSkuMaps[s.sku];
                  _this.spList.push({
                    id: cartonSku ? cartonSku.id : "",
                    weight: cartonSku ? cartonSku.weight : "",
                    currency: cartonSku ? cartonSku.currency : "",
                    sku: s.sku,
                    zhName: cartonSku ? cartonSku.zhName : "",
                    enName: cartonSku ? cartonSku.enName : "",
                    code: cartonSku ? cartonSku.code : "",
                    money: cartonSku ? cartonSku.money : "",
                    img: cartonSku ? cartonSku.img : "",
                    number: s.number
                  });
                });
              } else {
                console.log(res.data.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          _this.guigeArr[index].skus = new Array();
          _this.spList = JSON.parse(JSON.stringify(_this.guigeArr[index].skus));
        }
        _this.spListIndex = index;
        _this.spListIndexData = _this.guigeArr[index];
        _this.listTable = true;
      }
    },
    //删除
    handleDeleteGuige(item, index) {
      this.guigeArr.splice(index, 1);
      this.orderForm.packingList.totalCarton =
        this.orderForm.packingList.totalCarton - item.number;
    },
    //-------------------商品信息------------------
    //新增/编辑商品信息
    spHandleEdit(index, row) {
      let _this = this;
      _this.addSPinfo = true;
      _this.imgFile = [];
      if (row) {
        _this.editProductTitle = "编辑商品信息";
        _this.nextAddProductButton = false;
        _this.tmpProduct = row;
        let file = new Object();
        file.url = row.img;
        _this.imgFile.push(file);
      } else {
        _this.editProductTitle = "新增商品信息";
        _this.nextAddProductButton = true;
        _this.tmpProduct = {
          id: "",
          currency: "",
          sku: "",
          weight: "",
          nameCn: "",
          nameEn: "",
          hscode: "",
          price: "",
          img: ""
        };
        _this.addImg = "";
      }
    },
    //删除商品信息
    spHandleDelete(index, row) {
      this.spList.splice(index, 1);
    },
    //历史商品列表选中
    handleSelectionChange(val) {
      this.spListSelection = val;
    },
    //历史商品列表保存
    handleSaveSp() {
      this.lishiTable = false;
      // console.log(this.spList);
      this.spListSelection.forEach((d, i) => {
        let _d = this.clone(d);
        this.spList.push(_d);
      });
    },

    currentPage(page) {
      this.productHistoryList.page = page;
      this.loadProducts();
    },
    skuEditClose() {
      let _this = this;
      let _removeIndex = new Array();
      if (_this.spList) {
        for (let i = 0; i < _this.spList.length; i++) {
          if (!_this.spList[i].number || _this.spList[i].number <= 0) {
            _this.spList.splice(i, 1);
            i--;
          }
        }
      }
      // console.log(_this.spList);
    },
    //sku数据保存
    skuSaveSp() {
      let _this = this;
      let _isFailed = false;
      _this.spList.forEach((data, index) => {
        if (!data.number || data.number <= 0 || isNaN(data.number)) {
          _isFailed = true;
        }
      });
      if (_isFailed) {
        _this.$message.error("SKU数量必须为大于0的数字");
      } else {
        _this.listTable = false;
      }
      if (_this.spListIndexData && _this.spListIndexData != "") {
        _this.spListIndexData.skus = JSON.parse(JSON.stringify(_this.spList));
        _this.$set(_this.guigeArr, _this.spListIndex, _this.spListIndexData);
      }
    },
    loadProducts() {
      //初始化sku
      let _this = this;
      _this.$request1
        .post(
          '/sku/query',
          {
              currentPage: _this.productHistoryList.page,
              pageSize: _this.productHistoryList.pageSize
            },
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(res => {
          // console.log(res);
          if (res.data && res.data.data.length > 0) {
            _this.productData = res.data.data;
            _this.productHistoryList.total = res.data.total;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    imgChange(file, fileList) {
      this.addImg = file.raw;
    },
    //新增/编辑商品信息保存
    handleAddSp(index, row) {
      this.addProduct(true);
    },
    handleAddSpContinue() {
      this.addProduct(false);
    },
    getFormData(form, pic) {
      let _this = this;
      var formData = new FormData();
      for (var key in form) {
        formData.append(key, form[key]);
      }
      formData.append("pic", pic);
      return formData;
    },
    addProduct(closeEdit) {
      // let _this = this;
      // let _valid = true;
      // _this.$refs["tmpProduct"].validate(valid => {
      //   if (!valid) {
      //     _valid = false;
      //   }
      // });
      // if (!_valid) {
      //   return false;
      // }
      // let form = _this.tmpProduct;
      // let formData = _this.getFormData(form, _this.addImg);

      // _this.$request1
      //   .post(
      //     jsRoutes.controllers.base.ProductController.addAndUpdateProduct(),
      //     formData,
      //     {
      //       withCredentials: true
      //     }
      //   )
      //   .then(function(res) {
      //     // console.log(res);
      //     if (res.data.success) {
      //       if (res.data.data && res.data.data.length > 0) {
      //         //添加到历史数据并添加到列表
      //         if (!_this.tmpProduct || !_this.tmpProduct.id) {
      //           _this.spList.push(res.data.data[0]);
      //           _this.productData.push(res.data.data[0]);
      //           _this.productHistoryList.total += 1;
      //         }
      //       }
      //       if (closeEdit) {
      //         _this.addSPinfo = false;
      //       } else {
      //         _this.tmpProduct = {
      //           id: "",
      //           currency: "",
      //           sku: "",
      //           weight: "",
      //           nameCn: "",
      //           nameEn: "",
      //           hscode: "",
      //           price: "",
      //           img: ""
      //         };
      //         _this.addImg = "";
      //       }
      //     } else {
      //       _this.$message.error(res.data.message);
      //     }
      //   })
      //   .catch(function(error) {
      //     console.log(error);
      //     if (error.response.status === 413) {
      //       _this.$notify.error({
      //         title: "请求失败,异常提示:",
      //         message:
      //           "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
      //       });
      //     } else {
      //       _this.$notify.error({
      //         title: "请求失败,异常提示:",
      //         message: error.response.statusText,
      //         duration: 0
      //       });
      //     }
      //   });
    },
    // 图片本地上传预览
    previewFiles() {
      var preview = document.querySelector(".file-content img");
      var file = document.querySelector("input[type=file]").files[0];
      var reader = new FileReader();

      reader.addEventListener(
        "load",
        function() {
          if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
            preview.src = reader.result;
            preview.style.width = "50px";
            preview.style.height = "50px";
            preview.style.display = "block";
          } else {
            SPFunc.spAlert(
              _this,
              "请上传合法的图片类型，如:jpg, jpeg, png, gif"
            );
          }
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    editCartonSkus() {
      let _this = this;
      _this.listTable = true;
      _this.spList = _this.standardSkus;
      _this.spListIndexData = null;
      _this.spListIndex = -1;
    },
    saveAddressOfDeliver() {
      let _this = this;
      _this.addressFormVisible = false;
      _this.initialDataProvinceChina.forEach((d, i) => {
        if (_this.deliveryDetail.provinceId == d.id) {
          _this.orderForm.deliveryDetail.province = d.nameCn;
        }
      });
    },
    changedeliveryType(v) {
      let _this = this;
      if (v == "DELIVERY" || v == "DELIVERY_BY_EXPRESS") {
        //送货到仓库
        _this.orderForm.warehoustCode = _this.currentWarehouseAddress.id;
        _this.orderForm.deliveryDetail.warehouseCode =
          _this.currentWarehouseAddress.id;
        _this.orderForm.deliveryDetail.contractName =
          _this.currentWarehouseAddress.receiptPersonName;
        _this.orderForm.deliveryDetail.phone =
          _this.currentWarehouseAddress.receiptPersonPhone;
        _this.orderForm.deliveryDetail.country =
          _this.currentWarehouseAddress.countryCode;
        _this.orderForm.deliveryDetail.province =
          _this.currentWarehouseAddress.province;
        _this.orderForm.deliveryDetail.city =
          _this.currentWarehouseAddress.city;
        _this.orderForm.deliveryDetail.addressFirst =
          _this.currentWarehouseAddress.address;
      } else if (v == "PICK_UP_FROM_CUSTOMER") {
        //上门取件
        _this.orderForm.deliveryDetail.contractName = "";
        _this.orderForm.deliveryDetail.phone = "";
        _this.orderForm.deliveryDetail.country = "";
        _this.deliveryDetail.provinceId = "";
        _this.orderForm.deliveryDetail.province = "";
        _this.orderForm.deliveryDetail.city = "";
        _this.orderForm.deliveryDetail.addressFirst = "";
      }
    },
    queryCountrys() {
      var _this = this;
      // console.info("productId："+_this.orderForm.productId);

      _this.$request1
        .get(
          '/country-filter-channel',
          {
            params: {
              channelId: _this.orderForm.productId
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          var result = response.data;
          if (response.status == 200 && result.success) {
            _this.initialDataCountry = result.data;
            _this.shippingDetail.countryId = result.data[0].id
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    querySearchCountry(queryString, cb) {
      var restaurants = this.initialDataCountry;
      restaurants.forEach((d, i) => {
        d.value = d.nameEn;
      });
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    queryProvince(countryId) {
      var _this = this;
      _this.initialDataCountry.forEach((d, i) => {
        if (d.id == _this.shippingDetail.countryId) {
          _this.orderForm.shippingDetail.country = d.code;
          _this.orderForm.localLanguageDetailValue.country = d.localLanguage;
        }
      });
      _this.$request1
        .get(
          '/province/' + countryId + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataProvince = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryProvinceOfChina() {
      var _this = this;
      _this.$request1
        .get(
          '/province/' + 1 + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataProvinceChina = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryCity(provinceId) {
      var _this = this;
      _this.initialDataProvince.forEach((d, i) => {
        if (d.id == _this.shippingDetail.provinceId) {
          _this.orderForm.shippingDetail.province = d.nameCn;
          _this.orderForm.localLanguageDetailValue.province = d.localLanguage;
        }
      });
      _this.$request1
        .get(
          '/city/' + provinceId + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataCity = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    selectCity() {
      var _this = this;
      _this.initialDataCity.forEach((d, i) => {
        if (d.id == _this.shippingDetail.cityId) {
          _this.orderForm.shippingDetail.city = d.nameCn;
          _this.orderForm.localLanguageDetailValue.city = d.localLanguage;
        }
      });
    },
    queryCityOfChina(provinceId) {
      var _this = this;
      _this.orderForm.deliveryDetail.city = "";
      _this.initialDataProvinceChina.forEach((d, i) => {
        if (d.id == _this.orderForm.deliveryDetail.province) {
          _this.orderForm.deliveryDetail.province = d.nameCn;
        }
      });
      _this.$request1
        .get(
          '/city/' + provinceId + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataCityChina = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    buildingOrderForm() {
      //校验表单格式
      let _this = this;
      _this.orderForm.warehoustCode = _this.currentWarehouseAddress.id;
      if (
        _this.fbaChecked &&
        _this.orderForm.customerRefnumber.fbaNumber != "无"
      ) {
        _this.orderForm.shippingDetail.contractName = "amazon";
        _this.orderForm.shippingDetail.phone = "9999999999";
      }
      let _validHead = true;
      _this.$refs["orderForm1"].validate(valid => {
        if (!valid) {
          _validHead = false;
        }
      });

      let _validBody = true;
      _this.$refs["orderForm2"].validate(valid => {
        if (!valid) {
          _validBody = false;
        }
      });
      let _validBottom = true;
      _this.$refs["orderForm3"].validate(valid => {
        if (!valid) {
          _validBottom = false;
        }
      });

      if (!_validHead || !_validBody || !_validBottom) {
        return false;
      }
      let _realTotalCount = 0;
      if (_this.productForm.guigeRadio == 2) {
        if (!_this.guigeArr || _this.guigeArr.length <= 0) {
          _this.$message.error("箱子信息和sku信息必填");
          return false;
        } else {
          let _checkout = true;
          _this.guigeArr.forEach((d, i) => {
            if (!d.skus || d.skus.length <= 0) {
              _checkout = false;
            }
            if (!d.number || d.number <= 0 || isNaN(d.number)) {
              _checkout = false;
            } else {
              _realTotalCount += parseInt(d.number);
            }
            if (!_this.formData.usMeasure) {
              if (!d.long || d.long <= 0) {
                _checkout = false;
              }
              if (!d.width || d.width <= 0) {
                _checkout = false;
              }
              if (!d.height || d.height <= 0) {
                _checkout = false;
              }
              if (!d.weight || d.weight <= 0) {
                _checkout = false;
              }
            }
          });
          if (!_checkout) {
            _this.$message.error("箱子信息和sku信息必填,且箱明细数据必须大于0");
            return false;
          }
        }
      }

      let _totalCarton = parseInt(_this.orderForm.packingList.totalCarton);
      var cartonDetails = new Array();

      //箱子规格不同_totalCarton
      if (_realTotalCount != _totalCarton) {
        _this.$message.error(
          "箱规格不相同时，界面上填的货物箱数必须和明细里填的货物箱数的总数一致。"
        );
        return false;
      }
      _this.guigeArr.forEach((d, i) => {
        let _number = parseInt(d.number);

        var item = new Array();
        d.skus.forEach((d, i) => {
          var obj = new Object();
          obj.sku = d.sku;
          obj.qty = d.number;
          item.push(obj);
        });

        for (let i = 0; i < _number; i++) {
          var cartonDetail = new Object();
          if (!_this.formData.usMeasure) {
            if (i == 0) {
              cartonDetail.customerCartonNumber = d.customerCartonNumber;
            }
            cartonDetail.length = parseFloat(d.long);
            cartonDetail.width = parseFloat(d.width);
            cartonDetail.height = parseFloat(d.height);
            cartonDetail.weight = parseFloat(d.weight);
          } else {
            cartonDetail.length = 0;
            cartonDetail.width = 0;
            cartonDetail.height = 0;
            cartonDetail.weight = 0;
          }
          cartonDetail.items = item;
          cartonDetails.push(cartonDetail);
        }
      });

      _this.orderForm.packingList.cartonDetails = cartonDetails;
      return true;
    },

    //提交订单
    editOrderSubmit() {
      let _this = this;
      if (!this.buildingOrderForm()) {
        return;
      }
      if (_this.originCustomsId && !_this.orderForm.customsId) {
        //如果原始清关行Id不为空 orderForm里得清关行为空则使用原始清关行Id
        _this.orderForm.customsId = _this.originCustomsId;
      }
      this.$confirm("您确定要修改订单吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1({
            method: 'POST',
            url: '/order/' + this.editOrderId + '/edit/done',
            data: this.orderForm,
            xhrFields: {
              withCredentials: true
            }
          })
            .then(function(res) {
              // console.log(res);
              if (res.data.success) {
                _this.$alert(_this.editOrderId, "修改成功", {
                  confirmButtonText: "确定",
                  callback: action => {
                    _this.$router.push("/order");
                  }
                });
              } else {
                _this.$alert(res.data.message, "异常提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改"
          });
        });
    },
    queryWarehouseData() {
      var _this = this;
      this.$request1({
        method: 'GET',
        url: '/warehouse',
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          let result = response.data;
          _this.warehouseData = response.data.data;
          _this.flag = false;
          if (_this.warehouseData.length > 1) {
            _this.flag = true;
          }
          // this.getMapForm(this.warehouseData[0]);
          // console.log("warehoueAddress:"+JSON.stringify(this.warehouseData));
          _this.warehouse = [];
          response.data.data.forEach((d, i) => {
            d.title = d.name;
            d.address = d.address;
            d.position = d.position.split(",");

            let warehouse = { id: "", title: "" };
            warehouse.id = d.id;
            warehouse.title = d.name;
            _this.warehouse.push(warehouse);
          });
          _this.initialDataWarehouseAddress = response.data.data;
          // _this.warehouseId = this.warehouseData[0].id;
          let defaultWarehouse = _this.warehouseData.find(item => {
            return item.id === _this.default_warehouseCode;
          });
          if (defaultWarehouse) {
            _this.warehouseId = defaultWarehouse.id;
            this.getMapForm(defaultWarehouse);
          } else {
            _this.warehouseId = this.warehouseData[0].id;
            this.getMapForm(this.warehouseData[0]);
          }
          // console.info("this.warehouseId:"+_this.warehouseId);
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeFbaWarehouseCode() {
      let _this = this;
      _this.initialDataFbaAddress.forEach((d, i) => {
        if (d.id == _this.orderForm.shippingDetail.fbaWarehouseCode) {
          _this.orderForm.shippingDetail.country = d.country;
          _this.orderForm.shippingDetail.province = d.state;
          _this.orderForm.shippingDetail.city = d.city;
          _this.orderForm.shippingDetail.zipcode = d.postCode;
          _this.orderForm.shippingDetail.fbaWarehouseCode = d.warehouseCode;
          _this.orderForm.shippingDetail.addressFirst = d.address;
          _this.orderForm.localLanguageDetailValue.country = "";
          _this.orderForm.localLanguageDetailValue.province = "";
          _this.orderForm.localLanguageDetailValue.city = "";

          _this.initialDataCountry.forEach((c, j) => {
            if (d.country == c.code) {
              _this.orderForm.localLanguageDetailValue.country =
                c.localLanguage;
              _this.queryProvince(c.id);
            }
          });
          setTimeout(() => {
            _this.initialDataProvince.forEach((p, j) => {
              if (d.state == p.code || d.state == p.nameEn) {
                _this.orderForm.localLanguageDetailValue.province =
                  p.localLanguage;
                _this.queryCity(p.id);
              }
            });
          }, 500);
          setTimeout(() => {
            _this.initialDataCity.forEach((city, j) => {
              if (d.city == city.nameEn) {
                _this.orderForm.localLanguageDetailValue.city =
                  city.localLanguage;
              }
            });
          }, 1000);
        }
      });
    },
    queryFbaAddress() {
      let _this = this;
      _this.$request1
        .get(
          '/fba-warehouse',
          {
            params: {
              channelId: _this.orderForm.productId
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataFbaAddress = response.data.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    loadCustomerAddress() {
      let _this = this;
      let _orgOwner = _this.$route.query.customer;
      if (!_orgOwner || _orgOwner.length == 0) {
      } else {
        _this.$request1
          .get(
            jsRoutes.controllers.customer.CustomerController.loadCustomerAddress(_orgOwner),
            {
              withCredentials: true,
              headers: {
                "content-type": "application/json"
              }
            }
          )
          .then(res => {
            if (res.data.success && res.data.total > 0) {
              _this.orderForm.deliveryDetail.province = res.data.data.province;
              _this.orderForm.deliveryDetail.city = res.data.data.city;
              _this.orderForm.deliveryDetail.addressFirst =
                res.data.data.address;
              _this.orderForm.deliveryDetail.contractName = res.data.data.name;
              _this.orderForm.deliveryDetail.phone = res.data.data.phone;

              if (
                _this.initialDataProvinceChina &&
                _this.initialDataProvinceChina.length > 0
              ) {
                _this.initialDataProvinceChina.forEach((d, i) => {
                  if (d.nameCn == res.data.data.province) {
                    _this.orderForm.deliveryDetail.provinceId = d.id;
                    _this.deliveryDetail.provinceId = d.id;
                  }
                });
              }
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    changeShippingAddressType() {
      let _this = this;
      if (!_this.fbaChecked) {
        _this.orderForm.shippingDetail.contractName = "";
        _this.orderForm.shippingDetail.phone = "";
      }
    },
    selectWarehouse() {
      let _this = this;
      _this.warehouseData.forEach((item, index) => {
        if (item.id == _this.warehouseId) {
          _this.getMapForm(item);
          _this.userCarry[0].title = item.name;
          _thisthis.userCarry[0].address = item.address;
          _this.userCarry[0].name = item.receiptPersonName;
          _this.userCarry[0].phone = item.phone;
        }
      });
    },
    queryAddress(type) {
      this.$request1({
        method: 'GET',
        url: '/address/query',
        params: {
          type: type
        }
      })
        .then(res => {
          // console.log("shipping adress", res);

          if (res.data.success) {
            if (res.data.data && res.data.data.length > 0) {
              this.shippingList = res.data.data;
              this.shippingList.forEach((d, i) => {
                if (d.defaultAddress) {
                  this.selectShippingAddress(d.id);
                }
              });
            } else {
              this.shippingList = [];
            }
          } else {
            _this.$message.error(res.data.message);
            this.shippingList = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    selectShippingAddress(id) {
      this.shippingList.forEach((d, i) => {
        if (d.id == id) {
          this.shippingId = id;
          this.orderForm.deliveryDetail.province = d.province;
          this.orderForm.deliveryDetail.city = d.city;
          this.orderForm.deliveryDetail.addressFirst = d.address;
          this.orderForm.deliveryDetail.contractName = d.name;
          this.orderForm.deliveryDetail.phone = d.phone;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#sp-amap {
  position: fixed;
  top: 0;
  right: 100%;
  &.isOpen {
    position: relative;
    right: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/order/editorder.vue